import thunk from "redux-thunk";
import { configureStore, combineReducers } from "@reduxjs/toolkit";

import filter from "./filter/reducer";
import reload from "./reload/reducer";
import session from "./session/reducer";
import language from "./language/reducer";

const enhancers = [];
const preloadedState = {};

const store = configureStore({
  reducer: combineReducers({
    language,
    session,
    reload,
    filter,
  }),
  preloadedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
  enhancers,
});

export default store;
